import { useState } from "react";
import FormTwo from "../ProfileUser/Signup//FormTow";
import FormThree from "../ProfileUser/Signup//FormThree";
import FormFinal from "../ProfileUser/Signup//FormFinal";
const Signup = () => {
    const token = localStorage.getItem("userToken");
console.log("token---0>",token);

    const [step, setStep] = useState(1);

    const [formData, setFormData] = useState({
        name: "",
        father_name: "",
        number: "",
        email: "",
        dob: "",
        gender: "",


    });

    const nextStep = () => {
        setStep(step + 1);
    };

    const prevStep = () => {
        setStep(step - 1);
    };

    // const handleInputData = (input) => (e) => {
    //     const { value } = e.target;
    //     setFormData((prevState) => ({
    //         ...prevState,
    //         [input]: value,
    //     }));
    // };

    const handleInputData = (input) => (e) => {
        const value = e.target?.value;  // Using optional chaining to safely access value
        if (value !== undefined) {
            setFormData((prevState) => ({
                ...prevState,
                [input]: value,
            }));
        }
    };

    switch (step) {
        case 1:
            return (
                <div className="h-[100vh] md:flex justify-center items-center">

                    <FormTwo
                        nextStep={nextStep}
                        prevStep={prevStep}
                        handleFormData={handleInputData}
                        values={formData}
                    />
              
                </div>
            );
        case 2:
          return (
            <div className="h-[100vh] md:flex justify-center items-center">
           
                <FormThree
                    nextStep={nextStep}
                    prevStep={prevStep}
                    handleFormData={handleInputData}
                    values={formData}
                />
        
            </div>
        );
        case 3:
          return (
            <div className="h-[100vh] md:flex justify-center items-center">
             
                <FormFinal
                    nextStep={nextStep}
                    prevStep={prevStep}
                    handleFormData={handleInputData}
                    values={formData}
                />
            
            </div>
        );

        default:
            return (
                <div className="flex justify-center items-center min-h-screen bg-gray-100">
                    Invalid Step
                </div>
            );
    }
};

export default Signup;
